import React from "react" ;
import { ReactNode } from "react" ;
import ObservableState from "../utils/ObservableState" ;
import * as ui from "../native" ;
import ObservableComponent from "./ObservableComponent" ;
import BaseUIProps , { copyBaseUIProps } from "../native/ui/BaseUIProps" ;
import ObjectObservable from "../utils/ObjectObservable" ;
import DemoCreationView from "./DemoCreationView" ;
import BlockedLeadsByUser from "../classes/BlockedLeadsByUser" ;
import LabelWithInputField from "./LabelWithInputField" ;
import ResultStatus from "../classes/ResultStatus" ;
import BlockedLeadsByUserRequest from "../models/BlockedLeadsByUserRequest" ;
import MeetingDTO from "../models/MeetingDTO" ;
import DomineOwners from "../classes/DomineOwners" ;
import Popup from "./Popup" ;
import MaterialIcons from "../icons/MaterialIcons" ;
import User from "../models/User" ;
import UserRole from "../classes/UserRole" ;
import IconButton from "./IconButton" ;
import SortedHeader from "./SortedHeader" ;
import LeadUtils from "../classes/LeadUtils" ;
import Result from "../classes/Result" ;
import Query from "../classes/Query" ;
import MessageDispatch from "../rocket/MessageDispatch" ;
import Button from "./Button" ;
import ListWrapper from "../utils/ListWrapper" ;
import LeadRemainder from "../models/LeadRemainder" ;
import TextView from "./TextView" ;
import FailureMessage from "../classes/FailureMessage" ;
import DomineOwnersRequest from "../models/DomineOwnersRequest" ;
import UserBlockedLead from "../models/UserBlockedLead" ;
import CollectionUtils from "../utils/CollectionUtils" ;
import UserRemaindersRequest from "../models/UserRemaindersRequest" ;
import SuccessMessage from "../classes/SuccessMessage" ;
import LeadRemainderStatus from "../classes/LeadRemainderStatus" ;
import MicroSoftAcc from "../models/MicroSoftAcc" ;
import EventBus from "../utils/EventBus" ;
import UserRemainders from "../classes/UserRemainders" ;
import Browser from "../classes/Browser" ;
import ScrollView2 from "./ScrollView2" ;
import Company from "../models/Company" ;
import SubSideMenuButton from "./SubSideMenuButton" ;
import DateTime from "../core/DateTime" ;
import RPCServices from "../rpc/RPCServices" ;
import IconView from "./IconView" ;
import DomineOwner from "../models/DomineOwner" ;
import CompanyContact from "../models/CompanyContact" ;
import { UsageConstants } from "../rocket/D3ETemplate" ;
import { BuildContext } from "../classes/BuildContext" ;

type _SearchButtonOnPressed = ( d3eState : GeneralSettingsPageRefs ) => void ;

type _AddMeetingButtonOnPressed = ( d3eState : GeneralSettingsPageRefs ) => void ;

type _JoinButtonOnPressed = ( d3eState : _MeetingState ) => void ;

type _UnblockButtonOnPressed = ( d3eState : _BlockedUserState ) => void ;

type _LabelWithInputFieldOnChanged = ( text : string,d3eState : GeneralSettingsPageRefs ) => void ;

type _LabelWithInputField1OnChanged = ( text : string,d3eState : GeneralSettingsPageRefs ) => void ;


  export  interface  GeneralSettingsPageProps extends  BaseUIProps {   key?: string ;
   company: Company ;
   currentUser: User ;
 }
/// To store state data for GeneralSettingsPage 
   class  GeneralSettingsPageRefs {  public addMeetingButton: AddMeetingButtonState = new AddMeetingButtonState() ;
  public blockedUserState: Map<UserBlockedLead, _BlockedUserState> = new Map() ;
   column1ScrollController: ui.ScrollController = new ui.ScrollController() ;
   column2ScrollController: ui.ScrollController = new ui.ScrollController() ;
   column3ScrollController: ui.ScrollController = new ui.ScrollController() ;
   column4ScrollController: ui.ScrollController = new ui.ScrollController() ;
   column5ScrollController: ui.ScrollController = new ui.ScrollController() ;
  public forItemState: Map<CompanyContact, _ForItemState> = new Map() ;
  public meetingState: Map<MeetingDTO, _MeetingState> = new Map() ;
  public searchButton: SearchButtonState = new SearchButtonState() ;
  public forBlockedUser ( blockedUser : UserBlockedLead ) : _BlockedUserState {
 let res=this.blockedUserState.get(blockedUser);

if ( res == null ) {
 res=new _BlockedUserState(this,blockedUser);

this.blockedUserState.set(blockedUser,res);
 }

return res ; 
 }
  public forForItem ( forItem : CompanyContact ) : _ForItemState {
 let res=this.forItemState.get(forItem);

if ( res == null ) {
 res=new _ForItemState(this,forItem);

this.forItemState.set(forItem,res);
 }

return res ; 
 }
  public forMeeting ( meeting : MeetingDTO ) : _MeetingState {
 let res=this.meetingState.get(meeting);

if ( res == null ) {
 res=new _MeetingState(this,meeting);

this.meetingState.set(meeting,res);
 }

return res ; 
 }
 }

   interface  UnblockButtonWithStateProps extends  BaseUIProps {   key?: string ;
   d3eState: _BlockedUserState ;
   _onUnblockButtonPressed?: _UnblockButtonOnPressed ;
 }

   class  UnblockButtonState extends  ObjectObservable {  private _disable: boolean = false ;
  public _hover: boolean = false ;
  public get disable (  ) : boolean {
 return this._disable ; 
 }
  public setDisable ( val : boolean ) {
 let isValChanged :boolean=this._disable !== val;

if ( !isValChanged ) {
 return ; 
 }

this._disable=val;

this.fire('disable',this);
 }
  public get hover (  ) : boolean {
 return this._hover ; 
 }
  public setHover ( val : boolean ) {
 let isValChanged :boolean=this._hover !== val;

if ( !isValChanged ) {
 return ; 
 }

this._hover=val;

this.fire('hover',this);
 }
 }

   class  _UnblockButtonWithState extends  ObservableComponent<UnblockButtonWithStateProps> {   unblockButtonFocusNode: ui.FocusNode = new ui.FocusNode() ;
   static contextType = BuildContext ;
   context: React.ContextType<typeof BuildContext> ;
 public constructor ( props : UnblockButtonWithStateProps ) {
 super(props);

this.initState();
 }
  public get unblockButton (  ) : UnblockButtonState {
 return this.props.d3eState.unblockButton ; 
 }
  public get d3eState (  ) : _BlockedUserState {
 return this.props.d3eState ; 
 }
  public get _onUnblockButtonPressed (  ) : _UnblockButtonOnPressed {
 return this.props._onUnblockButtonPressed ; 
 }
  public initState (  ) {
 super.initState();

this.updateObservable('unblockButton',null,this.unblockButton);

this.initListeners();

this.enableBuild=true;
 }
  public initListeners (  ) : void {
 this.on([ 'unblockButton', 'unblockButton.Button', 'unblockButton.hover' ],this.rebuild);
 }
  public unblockButtonOnEnter ( event ) : void {
 return this.unblockButton.setHover(true) ; 
 }
  public unblockButtonOnExit ( event ) : void {
 return this.unblockButton.setHover(false) ; 
 }
  public dispose (  ) : void {
 this.unblockButton.setHover(false);

super.dispose();
 }
  public render (  ) : ReactNode {
 let cStyle=this.context.theme;

return ui.Container({ child:Button({ padding:cStyle.tButtonDangerPaddingOn, decoration:cStyle.tButtonDangerDecorationOn, disable:this.unblockButton.disable, onPressed:(  ) => {
 this._onUnblockButtonPressed(this.d3eState);
 }
, onFocusChange:( val ) => {
  }
, child:TextView({ data:'Unblock', className:'hc' }), onEnter:( event ) => {
 this.unblockButtonOnEnter(event);
 }
, onExit:( event ) => {
 this.unblockButtonOnExit(event);
 }
 }), className:'Danger xb81 hc' }) ; 
 }
 }
function UnblockButtonWithState ( props : UnblockButtonWithStateProps ) {
 return React.createElement(_UnblockButtonWithState,props) ; 
 }


   interface  JoinButtonWithStateProps extends  BaseUIProps {   key?: string ;
   d3eState: _MeetingState ;
   _onJoinMeetingButtonPressed?: _JoinButtonOnPressed ;
   meeting: MeetingDTO ;
 }

   class  JoinButtonState extends  ObjectObservable {  private _disable: boolean = false ;
  public get disable (  ) : boolean {
 return this._disable ; 
 }
  public setDisable ( val : boolean ) {
 let isValChanged :boolean=this._disable !== val;

if ( !isValChanged ) {
 return ; 
 }

this._disable=val;

this.fire('disable',this);
 }
 }

   class  _JoinButtonWithState extends  ObservableComponent<JoinButtonWithStateProps> {   joinButtonFocusNode: ui.FocusNode = new ui.FocusNode() ;
 public constructor ( props : JoinButtonWithStateProps ) {
 super(props);

this.initState();
 }
  public get joinButton (  ) : JoinButtonState {
 return this.props.d3eState.joinButton ; 
 }
  public get meeting (  ) : MeetingDTO {
 return this.props.meeting ; 
 }
  public get d3eState (  ) : _MeetingState {
 return this.props.d3eState ; 
 }
  public get _onJoinMeetingButtonPressed (  ) : _JoinButtonOnPressed {
 return this.props._onJoinMeetingButtonPressed ; 
 }
  public initState (  ) {
 super.initState();

this.updateObservable('joinButton',null,this.joinButton);

this.initListeners();

this.enableBuild=true;
 }
  public initListeners (  ) : void {
 this.updateSyncProperty('meeting',this.props.meeting);

this.on([ 'joinButton', 'meeting', 'meeting.joinUrl' ],this.rebuild);
 }
  public componentDidUpdate ( prevProps : JoinButtonWithStateProps ) : void {
 super.componentDidUpdate(prevProps);

if ( prevProps.meeting !== this.props.meeting ) {
 this.updateObservable('meeting',prevProps.meeting,this.props.meeting);

this.fire('meeting',this);
 }
 }
  public dispose (  ) : void {
 super.dispose();
 }
  public render (  ) : ReactNode {
 return Button({ disable:this.joinButton.disable, onPressed:(  ) => {
 this._onJoinMeetingButtonPressed(this.d3eState);
 }
, onFocusChange:( val ) => {
  }
, child:TextView({ data:this.meeting.joinUrl !== null ? this.meeting.joinUrl : '', className:'hc' }), className:'hc' }) ; 
 }
 }
function JoinButtonWithState ( props : JoinButtonWithStateProps ) {
 return React.createElement(_JoinButtonWithState,props) ; 
 }


   interface  AddMeetingButtonWithStateProps extends  BaseUIProps {   key?: string ;
   d3eState: GeneralSettingsPageRefs ;
   _onScheduleNewMeetingButtonPressed?: _AddMeetingButtonOnPressed ;
 }

   class  AddMeetingButtonState extends  ObjectObservable {  private _disable: boolean = false ;
  public _hover: boolean = false ;
  public get disable (  ) : boolean {
 return this._disable ; 
 }
  public setDisable ( val : boolean ) {
 let isValChanged :boolean=this._disable !== val;

if ( !isValChanged ) {
 return ; 
 }

this._disable=val;

this.fire('disable',this);
 }
  public get hover (  ) : boolean {
 return this._hover ; 
 }
  public setHover ( val : boolean ) {
 let isValChanged :boolean=this._hover !== val;

if ( !isValChanged ) {
 return ; 
 }

this._hover=val;

this.fire('hover',this);
 }
 }

   class  _AddMeetingButtonWithState extends  ObservableComponent<AddMeetingButtonWithStateProps> {   addMeetingButtonFocusNode: ui.FocusNode = new ui.FocusNode() ;
   static contextType = BuildContext ;
   context: React.ContextType<typeof BuildContext> ;
 public constructor ( props : AddMeetingButtonWithStateProps ) {
 super(props);

this.initState();
 }
  public get addMeetingButton (  ) : AddMeetingButtonState {
 return this.props.d3eState.addMeetingButton ; 
 }
  public get d3eState (  ) : GeneralSettingsPageRefs {
 return this.props.d3eState ; 
 }
  public get _onScheduleNewMeetingButtonPressed (  ) : _AddMeetingButtonOnPressed {
 return this.props._onScheduleNewMeetingButtonPressed ; 
 }
  public initState (  ) {
 super.initState();

this.updateObservable('addMeetingButton',null,this.addMeetingButton);

this.initListeners();

this.enableBuild=true;
 }
  public initListeners (  ) : void {
 this.on([ 'addMeetingButton', 'addMeetingButton.hover' ],this.rebuild);
 }
  public addMeetingButtonOnEnter ( event ) : void {
 return this.addMeetingButton.setHover(true) ; 
 }
  public addMeetingButtonOnExit ( event ) : void {
 return this.addMeetingButton.setHover(false) ; 
 }
  public dispose (  ) : void {
 this.addMeetingButton.setHover(false);

super.dispose();
 }
  public render (  ) : ReactNode {
 let cStyle=this.context.theme;

return ui.Container({ expand:true, margin:ui.EdgeInsets.fromLTRB(5.0,31.0,0.0,0.0,new Map()), width:120, child:Button({ padding:cStyle.tButtonPrimaryPaddingOn, decoration:cStyle.tButtonPrimaryDecorationOn, disable:this.addMeetingButton.disable, onPressed:(  ) => {
 this._onScheduleNewMeetingButtonPressed(this.d3eState);
 }
, onFocusChange:( val ) => {
  }
, child:TextView({ data:'Add Meeting', className:'hc' }), onEnter:( event ) => {
 this.addMeetingButtonOnEnter(event);
 }
, onExit:( event ) => {
 this.addMeetingButtonOnExit(event);
 }
 }), className:'Primary x9d6 hc' }) ; 
 }
 }
function AddMeetingButtonWithState ( props : AddMeetingButtonWithStateProps ) {
 return React.createElement(_AddMeetingButtonWithState,props) ; 
 }


   interface  LinkedInButtonWithStateProps extends  BaseUIProps {   key?: string ;
   d3eState: _ForItemState ;
   forItem: CompanyContact ;
 }

   class  LinkedInButtonState extends  ObjectObservable {  private _disable: boolean = false ;
  public get disable (  ) : boolean {
 return this._disable ; 
 }
  public setDisable ( val : boolean ) {
 let isValChanged :boolean=this._disable !== val;

if ( !isValChanged ) {
 return ; 
 }

this._disable=val;

this.fire('disable',this);
 }
 }

   class  _LinkedInButtonWithState extends  ObservableComponent<LinkedInButtonWithStateProps> {   linkedInButtonFocusNode: ui.FocusNode = new ui.FocusNode() ;
 public constructor ( props : LinkedInButtonWithStateProps ) {
 super(props);

this.initState();
 }
  public get forItem (  ) : CompanyContact {
 return this.props.forItem ; 
 }
  public get linkedInButton (  ) : LinkedInButtonState {
 return this.props.d3eState.linkedInButton ; 
 }
  public get d3eState (  ) : _ForItemState {
 return this.props.d3eState ; 
 }
  public initState (  ) {
 super.initState();

this.updateObservable('linkedInButton',null,this.linkedInButton);

this.initListeners();

this.enableBuild=true;
 }
  public initListeners (  ) : void {
 this.updateSyncProperty('forItem',this.props.forItem);

this.on([ 'forItem', 'forItem.linkedIn', 'linkedInButton' ],this.rebuild);
 }
  public componentDidUpdate ( prevProps : LinkedInButtonWithStateProps ) : void {
 super.componentDidUpdate(prevProps);

if ( prevProps.forItem !== this.props.forItem ) {
 this.updateObservable('forItem',prevProps.forItem,this.props.forItem);

this.fire('forItem',this);
 }
 }
  public dispose (  ) : void {
 super.dispose();
 }
  public render (  ) : ReactNode {
 return Button({ disable:this.linkedInButton.disable, onFocusChange:( val ) => {
  }
, child:TextView({ data:this.forItem?.linkedIn ?? '-', className:'hc' }), className:'hc' }) ; 
 }
 }
function LinkedInButtonWithState ( props : LinkedInButtonWithStateProps ) {
 return React.createElement(_LinkedInButtonWithState,props) ; 
 }


   interface  SearchButtonWithStateProps extends  BaseUIProps {   key?: string ;
   d3eState: GeneralSettingsPageRefs ;
   _onGetDomineContacts?: _SearchButtonOnPressed ;
 }

   class  SearchButtonState extends  ObjectObservable {  private _disable: boolean = false ;
  public _hover: boolean = false ;
  public get disable (  ) : boolean {
 return this._disable ; 
 }
  public setDisable ( val : boolean ) {
 let isValChanged :boolean=this._disable !== val;

if ( !isValChanged ) {
 return ; 
 }

this._disable=val;

this.fire('disable',this);
 }
  public get hover (  ) : boolean {
 return this._hover ; 
 }
  public setHover ( val : boolean ) {
 let isValChanged :boolean=this._hover !== val;

if ( !isValChanged ) {
 return ; 
 }

this._hover=val;

this.fire('hover',this);
 }
 }

   class  _SearchButtonWithState extends  ObservableComponent<SearchButtonWithStateProps> {   searchButtonFocusNode: ui.FocusNode = new ui.FocusNode() ;
   static contextType = BuildContext ;
   context: React.ContextType<typeof BuildContext> ;
 public constructor ( props : SearchButtonWithStateProps ) {
 super(props);

this.initState();
 }
  public get searchButton (  ) : SearchButtonState {
 return this.props.d3eState.searchButton ; 
 }
  public get d3eState (  ) : GeneralSettingsPageRefs {
 return this.props.d3eState ; 
 }
  public get _onGetDomineContacts (  ) : _SearchButtonOnPressed {
 return this.props._onGetDomineContacts ; 
 }
  public initState (  ) {
 super.initState();

this.updateObservable('searchButton',null,this.searchButton);

this.initListeners();

this.enableBuild=true;
 }
  public initListeners (  ) : void {
 this.on([ 'searchButton', 'searchButton.hover' ],this.rebuild);
 }
  public searchButtonOnEnter ( event ) : void {
 return this.searchButton.setHover(true) ; 
 }
  public searchButtonOnExit ( event ) : void {
 return this.searchButton.setHover(false) ; 
 }
  public dispose (  ) : void {
 this.searchButton.setHover(false);

super.dispose();
 }
  public render (  ) : ReactNode {
 let cStyle=this.context.theme;

return ui.Container({ expand:true, margin:ui.EdgeInsets.fromLTRB(5.0,31.0,0.0,0.0,new Map()), width:120, child:Button({ padding:cStyle.tButtonPrimaryPaddingOn, decoration:cStyle.tButtonPrimaryDecorationOn, disable:this.searchButton.disable, onPressed:(  ) => {
 this._onGetDomineContacts(this.d3eState);
 }
, onFocusChange:( val ) => {
  }
, child:TextView({ data:'Search', className:'hc' }), onEnter:( event ) => {
 this.searchButtonOnEnter(event);
 }
, onExit:( event ) => {
 this.searchButtonOnExit(event);
 }
 }), className:'Primary xdc7 hc' }) ; 
 }
 }
function SearchButtonWithState ( props : SearchButtonWithStateProps ) {
 return React.createElement(_SearchButtonWithState,props) ; 
 }


   class  _ForItemState {   parent: GeneralSettingsPageRefs ;
   forItem: CompanyContact ;
   linkedInButton: LinkedInButtonState = new LinkedInButtonState() ;
 public constructor ( parent,forItem ) {
 this.parent=parent;

this.forItem=forItem;
 }
 }

   class  _MeetingState {   parent: GeneralSettingsPageRefs ;
   meeting: MeetingDTO ;
   joinButton: JoinButtonState = new JoinButtonState() ;
 public constructor ( parent,meeting ) {
 this.parent=parent;

this.meeting=meeting;
 }
 }

   class  _BlockedUserState {   parent: GeneralSettingsPageRefs ;
   blockedUser: UserBlockedLead ;
   unblockButton: UnblockButtonState = new UnblockButtonState() ;
 public constructor ( parent,blockedUser ) {
 this.parent=parent;

this.blockedUser=blockedUser;
 }
 }

   class  _GeneralSettingsPageState extends  ObservableComponent<GeneralSettingsPageProps> {   static defaultProps = { company:null, currentUser:null } ;
   d3eState: GeneralSettingsPageRefs = new GeneralSettingsPageRefs() ;
   selectedMenu: string = 'Company Contacts' ;
   searchBy: string = '' ;
   contacts: Array<CompanyContact> = ListWrapper.widget(this,'contacts') ;
   request: DomineOwnersRequest = null ;
   query: DomineOwners = null ;
   dominHandlingUsers: Array<DomineOwner> = ListWrapper.widget(this,'dominHandlingUsers') ;
   userRemainderRequest: UserRemaindersRequest = null ;
   remainderQuery: UserRemainders = null ;
   reminders: Array<LeadRemainder> = ListWrapper.widget(this,'reminders') ;
   meetings: Array<MeetingDTO> = ListWrapper.widget(this,'meetings') ;
   currentMeeting: MeetingDTO = null ;
   blockListQuery: BlockedLeadsByUser = null ;
   blockedLeads: Array<UserBlockedLead> = ListWrapper.widget(this,'blockedLeads') ;
   demoCreationViewPopup: Popup ;
   static contextType = BuildContext ;
   context: React.ContextType<typeof BuildContext> ;
 public constructor ( props : GeneralSettingsPageProps ) {
 super(props);

this.initState();
 }
  public get company (  ) : Company {
 return this.props.company ; 
 }
  public get currentUser (  ) : User {
 return this.props.currentUser ; 
 }
  public initState (  ) {
 super.initState();

this.initListeners();

this.enableBuild=true;

this.onInit();
 }
  public initListeners (  ) : void {
 this.updateSyncProperty('company',this.props.company);

this.updateSyncProperty('currentUser',this.props.currentUser);

this.on([ 'request', 'request.domine' ],this.computeQuery);

this.computeQuery();

this.on([ 'query', 'query.items' ],this.computeDominHandlingUsers);

this.computeDominHandlingUsers();

this.on([ 'userRemainderRequest', 'userRemainderRequest.ascending', 'userRemainderRequest.orderBy', 'userRemainderRequest.user' ],this.computeRemainderQuery);

this.computeRemainderQuery();

this.on([ 'remainderQuery', 'remainderQuery.items' ],this.computeReminders);

this.computeReminders();

this.on([ 'currentUser' ],this.computeBlockListQuery);

this.computeBlockListQuery();

this.on([ 'blockListQuery', 'blockListQuery.items' ],this.computeBlockedLeads);

this.computeBlockedLeads();

this.on([ 'blockedLeads', 'blockedLeads.lead', 'blockedLeads.lead.name', 'blockedLeads.lead.phone', 'contacts', 'contacts.designation', 'contacts.email', 'contacts.name', 'contacts.phone', 'dominHandlingUsers', 'dominHandlingUsers.salesUser', 'dominHandlingUsers.salesUser.email', 'dominHandlingUsers.salesUser.firstName', 'dominHandlingUsers.salesUser.lastName', 'meetings', 'meetings.attendees', 'meetings.endTime', 'meetings.startTime', 'meetings.status', 'meetings.subject', 'reminders', 'reminders.createdBy', 'reminders.createdBy.firstName', 'reminders.description', 'reminders.lead', 'reminders.lead.name', 'reminders.remainderDate', 'reminders.status', 'reminders.title', 'request', 'request.domine', 'searchBy', 'selectedMenu', 'userRemainderRequest', 'userRemainderRequest.ascending', 'userRemainderRequest.orderBy' ],this.rebuild);
 }
  public componentDidUpdate ( prevProps : GeneralSettingsPageProps ) : void {
 super.componentDidUpdate(prevProps);

if ( prevProps.company !== this.props.company ) {
 this.updateObservable('company',prevProps.company,this.props.company);

this.fire('company',this);
 }

if ( prevProps.currentUser !== this.props.currentUser ) {
 this.updateObservable('currentUser',prevProps.currentUser,this.props.currentUser);

this.fire('currentUser',this);
 }
 }
  public setSelectedMenu ( val : string ) : void {
 let isValChanged :boolean=this.selectedMenu !== val;

if ( !isValChanged ) {
 return ; 
 }

this.selectedMenu=val;

this.fire('selectedMenu',this);
 }
  public setSearchBy ( val : string ) : void {
 let isValChanged :boolean=this.searchBy !== val;

if ( !isValChanged ) {
 return ; 
 }

this.searchBy=val;

this.fire('searchBy',this);
 }
  public setContacts ( val : Array<CompanyContact> ) : void {
 let isValChanged :boolean=CollectionUtils.isNotEquals(this.contacts,val);

if ( !isValChanged ) {
 return ; 
 }

this.updateObservableColl('contacts',this.contacts,val);

this.contacts.clear();

this.contacts.addAll(val);

this.fire('contacts',this);
 }
  public addToContacts ( val : CompanyContact,index : number = -1 ) : void {
 if ( index === -1 ) {
 if ( !this.contacts.contains(val) ) this.contacts.add(val);
 }
 else {
 this.contacts.remove(this.contacts.elementAt(index));

this.contacts.add(val);
 }

this.fire('contacts',this,val,true);

this.updateObservable('contacts',null,val);
 }
  public removeFromContacts ( val : CompanyContact ) : void {
 this.contacts.remove(val);

this.fire('contacts',this,val,false);

this.removeObservable('contacts',val);
 }
  public setRequest ( val : DomineOwnersRequest ) : void {
 let isValChanged :boolean=this.request !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateObservable('request',this.request,val);

this.request=val;

this.fire('request',this);
 }
  public setQuery ( val : DomineOwners ) : void {
 let isValChanged :boolean=this.query !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateObservable('query',this.query,val);

this.query=val;

this.fire('query',this);
 }
  public computeQuery  =  async  (  ) : Promise<void>  =>  {
 try {
 this.setQuery(( await Query.get().getDomineOwners(UsageConstants.QUERY_GETDOMINEOWNERS_GENERALSETTINGSPAGE_PROPERTIES_QUERY_COMPUTATION,this.request)));
 }
 catch ( exception ) {
 console.log(' exception in computeQuery : ' + exception.toString());

this.setQuery(null);
 }
 }
  public setDominHandlingUsers ( val : Array<DomineOwner> ) : void {
 let isValChanged :boolean=CollectionUtils.isNotEquals(this.dominHandlingUsers,val);

if ( !isValChanged ) {
 return ; 
 }

this.updateObservableColl('dominHandlingUsers',this.dominHandlingUsers,val);

this.dominHandlingUsers.clear();

this.dominHandlingUsers.addAll(val);

this.fire('dominHandlingUsers',this);
 }
  public addToDominHandlingUsers ( val : DomineOwner,index : number = -1 ) : void {
 if ( index === -1 ) {
 if ( !this.dominHandlingUsers.contains(val) ) this.dominHandlingUsers.add(val);
 }
 else {
 this.dominHandlingUsers.remove(this.dominHandlingUsers.elementAt(index));

this.dominHandlingUsers.add(val);
 }

this.fire('dominHandlingUsers',this,val,true);

this.updateObservable('dominHandlingUsers',null,val);
 }
  public removeFromDominHandlingUsers ( val : DomineOwner ) : void {
 this.dominHandlingUsers.remove(val);

this.fire('dominHandlingUsers',this,val,false);

this.removeObservable('dominHandlingUsers',val);
 }
  public computeDominHandlingUsers  =  (  ) : void  =>  {
 try {
 this.setDominHandlingUsers(Array.from(this.query.items.isNotEmpty ? this.query.items : [  ]));
 }
 catch ( exception ) {
 console.log(' exception in computeDominHandlingUsers : ' + exception.toString());

this.setDominHandlingUsers([  ]);
 }
 }
  public setUserRemainderRequest ( val : UserRemaindersRequest ) : void {
 let isValChanged :boolean=this.userRemainderRequest !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateObservable('userRemainderRequest',this.userRemainderRequest,val);

this.userRemainderRequest=val;

this.fire('userRemainderRequest',this);
 }
  public setRemainderQuery ( val : UserRemainders ) : void {
 let isValChanged :boolean=this.remainderQuery !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateObservable('remainderQuery',this.remainderQuery,val);

this.remainderQuery=val;

this.fire('remainderQuery',this);
 }
  public computeRemainderQuery  =  async  (  ) : Promise<void>  =>  {
 try {
 this.setRemainderQuery(( await Query.get().getUserRemainders(UsageConstants.QUERY_GETUSERREMAINDERS_GENERALSETTINGSPAGE_PROPERTIES_REMAINDERQUERY_COMPUTATION,this.userRemainderRequest)));
 }
 catch ( exception ) {
 console.log(' exception in computeRemainderQuery : ' + exception.toString());

this.setRemainderQuery(null);
 }
 }
  public setReminders ( val : Array<LeadRemainder> ) : void {
 let isValChanged :boolean=CollectionUtils.isNotEquals(this.reminders,val);

if ( !isValChanged ) {
 return ; 
 }

this.updateObservableColl('reminders',this.reminders,val);

this.reminders.clear();

this.reminders.addAll(val);

this.fire('reminders',this);
 }
  public addToReminders ( val : LeadRemainder,index : number = -1 ) : void {
 if ( index === -1 ) {
 if ( !this.reminders.contains(val) ) this.reminders.add(val);
 }
 else {
 this.reminders.remove(this.reminders.elementAt(index));

this.reminders.add(val);
 }

this.fire('reminders',this,val,true);

this.updateObservable('reminders',null,val);
 }
  public removeFromReminders ( val : LeadRemainder ) : void {
 this.reminders.remove(val);

this.fire('reminders',this,val,false);

this.removeObservable('reminders',val);
 }
  public computeReminders  =  (  ) : void  =>  {
 try {
 this.setReminders(Array.from(this.remainderQuery.items.isNotEmpty ? this.remainderQuery.items : [  ]));
 }
 catch ( exception ) {
 console.log(' exception in computeReminders : ' + exception.toString());

this.setReminders([  ]);
 }
 }
  public setMeetings ( val : Array<MeetingDTO> ) : void {
 let isValChanged :boolean=CollectionUtils.isNotEquals(this.meetings,val);

if ( !isValChanged ) {
 return ; 
 }

this.updateObservableColl('meetings',this.meetings,val);

this.meetings.clear();

this.meetings.addAll(val);

this.fire('meetings',this);
 }
  public addToMeetings ( val : MeetingDTO,index : number = -1 ) : void {
 if ( index === -1 ) {
 if ( !this.meetings.contains(val) ) this.meetings.add(val);
 }
 else {
 this.meetings.remove(this.meetings.elementAt(index));

this.meetings.add(val);
 }

this.fire('meetings',this,val,true);

this.updateObservable('meetings',null,val);
 }
  public removeFromMeetings ( val : MeetingDTO ) : void {
 this.meetings.remove(val);

this.fire('meetings',this,val,false);

this.removeObservable('meetings',val);
 }
  public setCurrentMeeting ( val : MeetingDTO ) : void {
 let isValChanged :boolean=this.currentMeeting !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateObservable('currentMeeting',this.currentMeeting,val);

this.currentMeeting=val;

this.fire('currentMeeting',this);
 }
  public setBlockListQuery ( val : BlockedLeadsByUser ) : void {
 let isValChanged :boolean=this.blockListQuery !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateObservable('blockListQuery',this.blockListQuery,val);

MessageDispatch.get().dispose(this.blockListQuery);

this.blockListQuery=val;

this.fire('blockListQuery',this);
 }
  public computeBlockListQuery  =  async  (  ) : Promise<void>  =>  {
 try {
 this.setBlockListQuery(( await Query.get().getBlockedLeadsByUser(UsageConstants.QUERY_GETBLOCKEDLEADSBYUSER_GENERALSETTINGSPAGE_PROPERTIES_BLOCKLISTQUERY_COMPUTATION,new BlockedLeadsByUserRequest({ user:this.currentUser }),{ 'synchronize':true })));
 }
 catch ( exception ) {
 console.log(' exception in computeBlockListQuery : ' + exception.toString());

this.setBlockListQuery(null);
 }
 }
  public setBlockedLeads ( val : Array<UserBlockedLead> ) : void {
 let isValChanged :boolean=CollectionUtils.isNotEquals(this.blockedLeads,val);

if ( !isValChanged ) {
 return ; 
 }

this.updateObservableColl('blockedLeads',this.blockedLeads,val);

this.blockedLeads.clear();

this.blockedLeads.addAll(val);

this.fire('blockedLeads',this);
 }
  public addToBlockedLeads ( val : UserBlockedLead,index : number = -1 ) : void {
 if ( index === -1 ) {
 if ( !this.blockedLeads.contains(val) ) this.blockedLeads.add(val);
 }
 else {
 this.blockedLeads.remove(this.blockedLeads.elementAt(index));

this.blockedLeads.add(val);
 }

this.fire('blockedLeads',this,val,true);

this.updateObservable('blockedLeads',null,val);
 }
  public removeFromBlockedLeads ( val : UserBlockedLead ) : void {
 this.blockedLeads.remove(val);

this.fire('blockedLeads',this,val,false);

this.removeObservable('blockedLeads',val);
 }
  public computeBlockedLeads  =  (  ) : void  =>  {
 try {
 this.setBlockedLeads(Array.from(this.blockListQuery.items.isNotEmpty ? this.blockListQuery.items : [  ]));
 }
 catch ( exception ) {
 console.log(' exception in computeBlockedLeads : ' + exception.toString());

this.setBlockedLeads([  ]);
 }
 }
  public render (  ) : ReactNode {
 let cStyle=this.context.theme;

return ui.Row({ children:[ ui.Column({ crossAxisAlignment:ui.CrossAxisAlignment.start, mainAxisAlignment:ui.MainAxisAlignment.start, children:[ ui.Column({ crossAxisAlignment:ui.CrossAxisAlignment.start, mainAxisAlignment:ui.MainAxisAlignment.start, children:[ ui.Row({ mainAxisAlignment:ui.MainAxisAlignment.spaceBetween, children:[ TextView({ data:'General Settings', style:new ui.TextStyle({color:cStyle.c14,fontSize:cStyle.tTextViewHeadlineSixFontSizeOn,fontWeight:cStyle.tTextViewHeadlineSixFontWeightOn}), className:'HeadlineSix x924a', key:'0' }), IconView({ icon:MaterialIcons.settings, color:cStyle.c14, size:20, className:'xe35', key:'1' }) ], className:'x036 hc h', key:'0' }), ui.Container({ margin:ui.EdgeInsets.fromLTRB(0.0,0.0,0.0,5.0,new Map()), child:SubSideMenuButton({ title:'Company Contacts', selectedMenu:this.selectedMenu, onPressed:(  ) => {
 this.onSearchByDomineButton(this.d3eState);
 }
 }), key:'1', className:'xfdb0 hc h' }), ui.Container({ margin:ui.EdgeInsets.symmetric({horizontal:0.0,vertical:5.0,transitions:new Map()}), child:SubSideMenuButton({ title:'Contacted Team', selectedMenu:this.selectedMenu, onPressed:(  ) => {
 this.onCompanyContactsButton(this.d3eState);
 }
 }), key:'2', className:'x73b hc h' }), ui.Container({ margin:ui.EdgeInsets.symmetric({horizontal:0.0,vertical:5.0,transitions:new Map()}), child:SubSideMenuButton({ title:'Remainders', selectedMenu:this.selectedMenu, onPressed:(  ) => {
 this.onPressedRemainderButton(this.d3eState);
 }
 }), key:'3', className:'xb9bd hc h' }), ui.Container({ margin:ui.EdgeInsets.symmetric({horizontal:0.0,vertical:5.0,transitions:new Map()}), child:SubSideMenuButton({ title:'Scheduled Activities', selectedMenu:this.selectedMenu, onPressed:(  ) => {
 this.onPressedScheduledButton(this.d3eState);
 }
 }), key:'4', className:'x98 hc h' }), ui.Container({ margin:ui.EdgeInsets.symmetric({horizontal:0.0,vertical:5.0,transitions:new Map()}), child:SubSideMenuButton({ title:'Blocked List', selectedMenu:this.selectedMenu, onPressed:(  ) => {
 this.onPressedBlockedListButton(this.d3eState);
 }
 }), key:'5', className:'x68 hc h' }) ], className:'x0af0 hc vc h v', key:'0' }) ], className:'x638 hc vc v', key:'0' }), ui.Column({ crossAxisAlignment:ui.CrossAxisAlignment.start, children:[ ((this.selectedMenu === 'Company Contacts') ? ScrollView2({child:ui.Column({ mainAxisAlignment:ui.MainAxisAlignment.start, crossAxisAlignment:ui.CrossAxisAlignment.start, children:[ ui.Row({ mainAxisAlignment:ui.MainAxisAlignment.center, crossAxisAlignment:ui.CrossAxisAlignment.center, children:[ ui.Container({ expand:true, margin:ui.EdgeInsets.fromLTRB(5.0,0.0,0.0,0.0,new Map()), child:LabelWithInputField({ name:'Enter Full Domine', placeHolder:'Domine', value:this.searchBy, onChanged:( text ) => {
 this.labelWithInputFieldonChanged(text,this.d3eState);
 }
 }), key:'0', className:'x1c9 hc h' }), SearchButtonWithState({ d3eState:this.d3eState, _onGetDomineContacts:this.onGetDomineContacts, key:'1' }) ], className:'xc30 hc', key:'0' }), ui.Table({ defaultColumnWidth:new ui.FlexColumnWidth(1), columnWidths:{0:new ui.FlexColumnWidth(1),1:new ui.FlexColumnWidth(1),2:new ui.FlexColumnWidth(1),3:new ui.FlexColumnWidth(1),4:new ui.FlexColumnWidth(1),}, key:this.contacts.length.toString(), children:[ ui.TableRow({ children:[ ui.TableCell({ child:TextView({ data:'Name', className:'hc' }), className:'TableCellHeader table-column xfd18 hc', key:'0' }), ui.TableCell({ child:TextView({ data:'Designation', className:'hc' }), className:'TableCellHeader table-column x71 hc', key:'1' }), ui.TableCell({ child:TextView({ data:'Email', className:'hc' }), className:'TableCellHeader table-column x7cd0 hc', key:'2' }), ui.TableCell({ child:TextView({ data:'Phone', className:'x69d4 hc' }), className:'TableCellHeader table-column x7df hc', key:'3' }), ui.TableCell({ child:TextView({ data:'LinkedIn', className:'x3d1d hc' }), className:'TableCellHeader table-column x95b hc', key:'4' }) ], className:'TableHeader table-row x1b5 hc', key:'0' }), (this.contacts).expand(( forItem ) => [ ui.TableRow({ children:[ ui.TableCell({ verticalAlignment:ui.TableCellVerticalAlignment.middle, child:TextView({ data:forItem?.name ?? '-', className:'hc' }), className:'table-column hc', key:'0' }), ui.TableCell({ verticalAlignment:ui.TableCellVerticalAlignment.middle, child:TextView({ data:forItem?.designation ?? '-', className:'hc' }), className:'table-column hc', key:'1' }), ui.TableCell({ verticalAlignment:ui.TableCellVerticalAlignment.middle, child:TextView({ data:forItem?.email ?? '-', className:'hc' }), className:'table-column hc', key:'2' }), ui.TableCell({ verticalAlignment:ui.TableCellVerticalAlignment.middle, child:TextView({ data:forItem?.phone ?? '-', className:'hc' }), className:'table-column hc', key:'3' }), ui.TableCell({ verticalAlignment:ui.TableCellVerticalAlignment.middle, child:LinkedInButtonWithState({ d3eState:this.d3eState.forForItem(forItem), forItem:forItem }), className:'table-column hc', key:'4' }) ], className:'TableRow1 table-row x0ff hc', key:forItem?.ident }) ]) ], className:'Table1 x878 hc h' }) ] }),scrollDirection:ui.Axis.vertical,className:'xdcb hc vc h v',controller:this.d3eState.column1ScrollController}) : [  ]), ((this.selectedMenu === 'Contacted Team') ? ScrollView2({child:ui.Column({ mainAxisAlignment:ui.MainAxisAlignment.start, crossAxisAlignment:ui.CrossAxisAlignment.start, children:[ ui.Row({ mainAxisAlignment:ui.MainAxisAlignment.center, crossAxisAlignment:ui.CrossAxisAlignment.center, children:[ ui.Container({ expand:true, margin:ui.EdgeInsets.fromLTRB(5.0,0.0,0.0,0.0,new Map()), child:LabelWithInputField({ name:'Enter Full Domine', placeHolder:'Domine', value:this.request.domine, onChanged:( text ) => {
 this.labelWithInputField1onChanged(text,this.d3eState);
 }
 }), key:'0', className:'x855 hc h' }) ], className:'xc3a hc', key:'0' }), ui.Table({ defaultColumnWidth:new ui.FlexColumnWidth(1), columnWidths:{0:new ui.FlexColumnWidth(1),1:new ui.FlexColumnWidth(1),2:new ui.FlexColumnWidth(1),3:new ui.FlexColumnWidth(1),}, children:[ ui.TableRow({ children:[ ui.TableCell({ child:TextView({ data:'Name', className:'hc' }), className:'TableCellHeader table-column x9f5 hc', key:'0' }), ui.TableCell({ child:TextView({ data:'Email', className:'hc' }), className:'TableCellHeader table-column x57be hc', key:'1' }), ui.TableCell({ child:TextView({ data:'Last Contacted', className:'hc' }), className:'TableCellHeader table-column x371 hc', key:'2' }) ], className:'TableHeader table-row xd64 hc', key:'0' }), (this.dominHandlingUsers).expand(( user ) => [ ui.TableRow({ children:[ ui.TableCell({ verticalAlignment:ui.TableCellVerticalAlignment.middle, child:TextView({ data:user.salesUser.firstName + ' ' + (user.salesUser?.lastName ?? ''), className:'hc' }), className:'table-column hc', key:'0' }), ui.TableCell({ verticalAlignment:ui.TableCellVerticalAlignment.middle, child:TextView({ data:user.salesUser.email, className:'hc' }), className:'table-column hc', key:'1' }), ui.TableCell({ verticalAlignment:ui.TableCellVerticalAlignment.middle, child:TextView({ data:'-', className:'hc' }), className:'table-column hc', key:'2' }) ], className:'TableRow1 table-row xd90 hc', key:user?.ident }) ]) ], className:'Table1 x4d3 hc h', key:'1' }) ] }),scrollDirection:ui.Axis.vertical,className:'x378 hc vc h v',controller:this.d3eState.column4ScrollController}) : [  ]), ((this.selectedMenu === 'Remainders') ? ScrollView2({child:ui.Column({ mainAxisAlignment:ui.MainAxisAlignment.start, crossAxisAlignment:ui.CrossAxisAlignment.start, children:[ ui.Table({ defaultColumnWidth:new ui.FlexColumnWidth(1), children:[ ui.TableRow({ children:[ ui.TableCell({ child:SortedHeader({ name:'Lead Name', assending:this.userRemainderRequest.ascending, sorted:this.userRemainderRequest.orderBy === 'name', onChanged:( value ) => {
 this.onNameSortedHeaderOnChangedHandler(value,this.d3eState);
 }
, className:'x19c hc h' }), className:'TableCellHeader table-column x09d hc h', key:'0' }), ui.TableCell({ child:SortedHeader({ name:'Title', assending:this.userRemainderRequest.ascending, sorted:this.userRemainderRequest.orderBy === 'title', onChanged:( value ) => {
 this.onTitleSortedHeaderOnChangedHandler(value,this.d3eState);
 }
, className:'x49f hc h' }), className:'TableCellHeader table-column x437 hc h', key:'1' }), ui.TableCell({ child:SortedHeader({ name:'Remainder Date', assending:this.userRemainderRequest.ascending, sorted:this.userRemainderRequest.orderBy === 'remainderDate', onChanged:( value ) => {
 this.onRemainderSortedHeaderOnChangedHandler(value,this.d3eState);
 }
, className:'x1f2 hc h' }), className:'TableCellHeader table-column xa0a hc h', key:'2' }), ui.TableCell({ child:TextView({ data:'Description', className:'hc' }), className:'TableCellHeader table-column x957 hc', key:'3' }), ui.TableCell({ child:SortedHeader({ name:'Status', assending:this.userRemainderRequest.ascending, sorted:this.userRemainderRequest.orderBy === 'status', onChanged:( value ) => {
 this.onStatusSortedHeaderOnChangedHandler(value,this.d3eState);
 }
, className:'x306 hc h' }), className:'TableCellHeader table-column xa55 hc h', key:'4' }), ui.TableCell({ child:TextView({ data:'Created By', className:'hc' }), className:'TableCellHeader table-column xf643 hc', key:'5' }) ], className:'TableHeader table-row xe6b hc h', key:'0' }), (this.reminders).expand(( reminder ) => [ ui.TableRow({ children:[ ui.TableCell({ verticalAlignment:ui.TableCellVerticalAlignment.middle, child:TextView({ data:reminder.lead.name, className:'hc' }), className:'table-column hc', key:'0' }), ui.TableCell({ verticalAlignment:ui.TableCellVerticalAlignment.middle, child:TextView({ data:reminder.title, className:'hc' }), className:'table-column hc', key:'1' }), ui.TableCell({ verticalAlignment:ui.TableCellVerticalAlignment.middle, child:TextView({ data:reminder.remainderDate !== null ? LeadUtils.toGMTFromDateTime(reminder.remainderDate.toDateTime(),{ format:'dd EEE, MMM y HH:mm' }) : '', className:'hc' }), className:'table-column hc', key:'2' }), ui.TableCell({ verticalAlignment:ui.TableCellVerticalAlignment.middle, child:TextView({ data:reminder.description, className:'hc' }), className:'table-column hc', key:'3' }), ui.TableCell({ verticalAlignment:ui.TableCellVerticalAlignment.middle, child:TextView({ data:reminder.status.name, className:'hc' }), className:'table-column hc', key:'4' }), ui.TableCell({ verticalAlignment:ui.TableCellVerticalAlignment.middle, child:TextView({ data:reminder.createdBy?.firstName ?? '-', className:'hc' }), className:'table-column hc', key:'5' }) ], className:'TableRow1 table-row xe93 hc', key:reminder?.ident }) ]) ], className:'Table1 x4ce hc h', key:'0' }) ] }),scrollDirection:ui.Axis.vertical,className:'x070a hc vc h v',controller:this.d3eState.column2ScrollController}) : [  ]), ((this.selectedMenu === 'Scheduled Activities') ? ScrollView2({child:ui.Column({ mainAxisAlignment:ui.MainAxisAlignment.start, crossAxisAlignment:ui.CrossAxisAlignment.start, children:[ ui.Row({ mainAxisAlignment:ui.MainAxisAlignment.center, crossAxisAlignment:ui.CrossAxisAlignment.center, children:[ TextView({ data:'Click on "Add Meeting" to create a new meeting', className:'x186', key:'0' }), ui.Container({ className:'x5af hc h', key:'1' }), AddMeetingButtonWithState({ d3eState:this.d3eState, _onScheduleNewMeetingButtonPressed:this.onScheduleNewMeetingButtonPressed, key:'2' }) ], className:'x12d hc', key:'0' }), ui.Table({ defaultColumnWidth:new ui.FlexColumnWidth(1), children:[ ui.TableRow({ children:[ ui.TableCell({ child:TextView({ data:'Subject', className:'hc' }), className:'TableCellHeader table-column xe3a hc', key:'0' }), ui.TableCell({ child:TextView({ data:'Activity Date & Time', className:'hc' }), className:'TableCellHeader table-column xe05 hc', key:'1' }), ui.TableCell({ child:TextView({ data:'Attendees', className:'hc' }), className:'TableCellHeader table-column x18b hc', key:'2' }), ui.TableCell({ child:TextView({ data:'Status', className:'hc' }), className:'TableCellHeader table-column x90b hc', key:'3' }), ui.TableCell({ child:TextView({ data:'Joinig Link', className:'hc' }), className:'TableCellHeader table-column x3fa hc', key:'4' }), ui.TableCell({ child:TextView({ data:'Actions', className:'hc' }), className:'TableCellHeader table-column xc8e hc', key:'5' }) ], className:'TableHeader table-row x4204 hc', key:'0' }), (this.meetings).expand(( meeting ) => [ ui.TableRow({ children:[ ui.TableCell({ verticalAlignment:ui.TableCellVerticalAlignment.middle, child:TextView({ data:meeting.subject, className:'hc' }), className:'table-column hc', key:'0' }), ui.TableCell({ verticalAlignment:ui.TableCellVerticalAlignment.middle, child:TextView({ data:meeting.startTime !== null && meeting.endTime !== null ? LeadUtils.toGMTFromDateTime(meeting.startTime,{ format:'dd EEE, MMM y HH:mm' }) + ' - ' + LeadUtils.toGMTFromDateTime(meeting.endTime,{ format:'dd EEE, MMM y HH:mm' }) : (meeting.startTime !== null ? LeadUtils.toGMTFromDateTime(meeting.startTime,{ format:'dd EEE, MMM y HH:mm' }) : (meeting.endTime !== null ? LeadUtils.toGMTFromDateTime(meeting.endTime,{ format:'dd EEE, MMM y HH:mm' }) : '')), className:'hc' }), className:'table-column hc', key:'1' }), ui.TableCell({ verticalAlignment:ui.TableCellVerticalAlignment.middle, child:TextView({ data:meeting.attendees.map(( a ) => a.split('@') [ 0 ]).join(', '), className:'hc' }), className:'table-column hc', key:'2' }), ui.TableCell({ verticalAlignment:ui.TableCellVerticalAlignment.middle, child:TextView({ data:meeting.status, className:'hc' }), className:'table-column hc', key:'3' }), ui.TableCell({ verticalAlignment:ui.TableCellVerticalAlignment.middle, child:JoinButtonWithState({ d3eState:this.d3eState.forMeeting(meeting), _onJoinMeetingButtonPressed:this.onJoinMeetingButtonPressed, meeting:meeting }), className:'table-column hc', key:'4' }), ui.TableCell({ verticalAlignment:ui.TableCellVerticalAlignment.middle, child:ui.Row({ children:[ IconButton({ icon:MaterialIcons.edit, onPressed:(  ) => {
 this.onMeetingEditButtonPressed(this.d3eState.forMeeting(meeting));
 }
, key:'0' }), IconButton({ icon:MaterialIcons.delete, onPressed:(  ) => {
 this.onMeetingDeleteButtonPressed(this.d3eState.forMeeting(meeting));
 }
, key:'1' }) ], className:'x150d hc h' }), className:'table-column x873 hc h', key:'5' }) ], className:'TableRow1 table-row x1ec hc h', key:meeting?.ident }) ]) ], className:'Table1 x269 hc h', key:'1' }) ] }),scrollDirection:ui.Axis.vertical,className:'x03f hc vc h v',controller:this.d3eState.column3ScrollController}) : [  ]), ((this.selectedMenu === 'Blocked List') ? ScrollView2({child:ui.Column({ mainAxisAlignment:ui.MainAxisAlignment.start, crossAxisAlignment:ui.CrossAxisAlignment.start, children:[ ui.Table({ defaultColumnWidth:new ui.FlexColumnWidth(1), children:[ ui.TableRow({ children:[ ui.TableCell({ child:TextView({ data:'Name', className:'hc' }), className:'TableCellHeader table-column xc7a hc', key:'0' }), ui.TableCell({ child:TextView({ data:'Contact', className:'hc' }), className:'TableCellHeader table-column xbba hc', key:'1' }), ui.TableCell({ child:TextView({ data:'Action', className:'hc' }), className:'TableCellHeader table-column xbe2 hc', key:'2' }) ], className:'TableHeader table-row x7e6 hc', key:'0' }), (this.blockedLeads).expand(( blockedUser ) => [ ui.TableRow({ children:[ ui.TableCell({ verticalAlignment:ui.TableCellVerticalAlignment.middle, child:TextView({ data:blockedUser.lead.name, className:'hc' }), className:'table-column hc', key:'0' }), ui.TableCell({ verticalAlignment:ui.TableCellVerticalAlignment.middle, child:TextView({ data:blockedUser.lead.phone, className:'hc' }), className:'table-column hc', key:'1' }), ui.TableCell({ verticalAlignment:ui.TableCellVerticalAlignment.middle, child:UnblockButtonWithState({ d3eState:this.d3eState.forBlockedUser(blockedUser), _onUnblockButtonPressed:this.onUnblockButtonPressed }), className:'table-column hc', key:'2' }) ], className:'TableRow1 table-row xafa8 hc', key:blockedUser?.ident }) ]) ], className:'Table1 xb5c hc h', key:'0' }) ] }),scrollDirection:ui.Axis.vertical,className:'xa27b hc vc h v',controller:this.d3eState.column5ScrollController}) : [  ]) ], className:'x449 hc vc h v', key:'1' }) ], className:ui.join('GeneralSettingsPage hc vc ' , this.props.className ?? ''), ...copyBaseUIProps(this.props,) }) ; 
 }
  public onInit  =  (  ) : void  =>  {
 this.setRequest(new DomineOwnersRequest({ domine:'' }));

this.setUserRemainderRequest(new UserRemaindersRequest({ user:this.currentUser.role === UserRole.Admin ? null : this.currentUser, ascending:true, orderBy:'remainderDate' }));
 }
  public onSearchByDomineButton  =  ( d3eState : GeneralSettingsPageRefs ) : void  =>  {
 this.setSelectedMenu('Company Contacts');
 }
  public onCompanyContactsButton  =  ( d3eState : GeneralSettingsPageRefs ) : void  =>  {
 this.setSelectedMenu('Contacted Team');
 }
  public onPressedRemainderButton  =  ( d3eState : GeneralSettingsPageRefs ) : void  =>  {
 this.setSelectedMenu('Remainders');
 }
  public onPressedBlockedListButton  =  ( d3eState : GeneralSettingsPageRefs ) : void  =>  {
 this.setSelectedMenu('Blocked List');
 }
  public onPressedScheduledButton  =  async  ( d3eState : GeneralSettingsPageRefs ) : Promise<void>  =>  {
 this.setSelectedMenu('Scheduled Activities');

if ( this.currentUser.mAccount === null ) {
 this.currentUser.setMAccount(new MicroSoftAcc({ user:this.currentUser }));

let result :Result<MicroSoftAcc>=( await this.currentUser.mAccount.save());

if ( result.status === ResultStatus.Success ) {
 this.openLink(this.currentUser);
 }
 else {
 EventBus.get().fire(new FailureMessage({ message:'Something went wrong please try again' }));
 }
 }
 else {
 if ( this.currentUser.mAccount.accessToken === null || this.currentUser.mAccount.accessToken.isEmpty ) {
 this.openLink(this.currentUser);
 }
 else if ( this.currentUser.mAccount.tokenExpersAt !== null && this.currentUser.mAccount.tokenExpersAt.isAfter(DateTime.now()) ) {
 let sheduledMeetings :Array<MeetingDTO>=( await RPCServices.getLeadService().fetchAppMeetings(this.currentUser.mAccount));

if ( sheduledMeetings !== null ) {
 this.setMeetings(sheduledMeetings);

EventBus.get().fire(new SuccessMessage({ message:'Fetched successfully' }));
 }
 else {
 EventBus.get().fire(new FailureMessage({ message:'Something went wrong' }));
 }
 }
 else {
 let refreshAccess :boolean=( await RPCServices.getLeadService().refreshAccessToken(this.currentUser.mAccount));

if ( refreshAccess ) {
 let sheduledMeetings :Array<MeetingDTO>=( await RPCServices.getLeadService().fetchAppMeetings(this.currentUser.mAccount));

if ( sheduledMeetings !== null ) {
 this.setMeetings(sheduledMeetings);

EventBus.get().fire(new SuccessMessage({ message:'Fetched successfully' }));
 }
 else {
 EventBus.get().fire(new FailureMessage({ message:'Something went wrong' }));
 }
 }
 else {
 this.openLink(this.currentUser);
 }
 }
 }
 }
  public openLink  =  async  ( user : User ) : Promise<void>  =>  {
 let link :string=( await RPCServices.getLeadService().createLink(user.mAccount));

if ( link !== null ) {
 Browser.open(link);
 }
 }
  public onUnblockButtonPressed  =  async  ( d3eState : _BlockedUserState ) : Promise<void>  =>  {
 let result :Result<UserBlockedLead>=( await d3eState.blockedUser.delete());

if ( result.status === ResultStatus.Success ) {
 this.blockedLeads.remove(d3eState.blockedUser);

EventBus.get().fire(new SuccessMessage({ message:'Lead unblocked successfully' }));
 }
 else {
 EventBus.get().fire(new FailureMessage({ message:'Failed to unblock lead. Please try again.' }));
 }
 }
  public onJoinMeetingButtonPressed  =  ( d3eState : _MeetingState ) : void  =>  {
 //  Handle join meeting button press
 }
  public onMeetingEditButtonPressed  =  ( d3eState : _MeetingState ) : void  =>  {
 //  Handle edit button press for meetings

this.setCurrentMeeting(d3eState.meeting);

this.showDemoCreationView();
 }
  public onMeetingDeleteButtonPressed  =  async  ( d3eState : _MeetingState ) : Promise<void>  =>  {
 //  Handle delete button press for meetings

let isCancelled :boolean=( await RPCServices.getLeadService().cancelMeeting(this.currentUser.mAccount,d3eState.meeting.eventId));

if ( isCancelled ) {
 this.meetings.remove(d3eState.meeting);

EventBus.get().fire(new SuccessMessage({ message:'Meeting cancelled successfully' }));
 }
 else {
 EventBus.get().fire(new FailureMessage({ message:'Failed to cancel meeting. Please try again.' }));
 }
 }
  public onGetDomineContacts  =  async  ( d3eState : GeneralSettingsPageRefs ) : Promise<void>  =>  {
 let items :Array<CompanyContact>=( await RPCServices.getApolloRPCService().fecthDomineContacts(this.searchBy));

if ( items !== null ) {
 this.setContacts(items);

EventBus.get().fire(new SuccessMessage({ message:'Fetched successfully' }));
 }
 else {
 EventBus.get().fire(new FailureMessage({ message:'Something went wrong' }));
 }
 }
  public onNameSortedHeaderOnChangedHandler  =  ( value : boolean,d3eState : GeneralSettingsPageRefs ) : void  =>  {
 this.userRemainderRequest.setOrderBy('name');

this.userRemainderRequest.setAscending(value);

this.setUserRemainderRequest(this.userRemainderRequest.deepClone());
 }
  public onTitleSortedHeaderOnChangedHandler  =  ( value : boolean,d3eState : GeneralSettingsPageRefs ) : void  =>  {
 this.userRemainderRequest.setOrderBy('title');

this.userRemainderRequest.setAscending(value);

this.setUserRemainderRequest(this.userRemainderRequest.deepClone());
 }
  public onRemainderSortedHeaderOnChangedHandler  =  ( value : boolean,d3eState : GeneralSettingsPageRefs ) : void  =>  {
 this.userRemainderRequest.setOrderBy('remainderDate');

this.userRemainderRequest.setAscending(value);

this.setUserRemainderRequest(this.userRemainderRequest.deepClone());
 }
  public onStatusSortedHeaderOnChangedHandler  =  ( value : boolean,d3eState : GeneralSettingsPageRefs ) : void  =>  {
 this.userRemainderRequest.setOrderBy('status');

this.userRemainderRequest.setAscending(value);

this.setUserRemainderRequest(this.userRemainderRequest.deepClone());
 }
  public onScheduleNewMeetingButtonPressed  =  ( d3eState : GeneralSettingsPageRefs ) : void  =>  {
 this.setCurrentMeeting(new MeetingDTO({ organizer:this.currentUser.firstName + ' ' + this.currentUser.lastName, subject:'', startTime:null, endTime:null, attendees:[  ] }));

this.showDemoCreationView();
 }
  public dispose (  ) : void {
 MessageDispatch.get().dispose(this.blockListQuery);

this.demoCreationViewPopup?.dispose();

super.dispose();
 }
  public showDemoCreationView ( d3eParams ? : Partial<{autoClose: boolean, model: boolean, float: boolean, takeFocus: boolean}> ) : void {
 let autoClose=d3eParams?.autoClose;

let model=d3eParams?.model;

let float=d3eParams?.float;

let takeFocus=d3eParams?.takeFocus;

this.demoCreationViewPopup ?. dispose();

this.demoCreationViewPopup=new Popup({autoClose:autoClose,model:model,float:float,takeFocus:takeFocus,position:ui.PopUpPosition.Center,child:ui.Container({ width:500, child:DemoCreationView({ user:this.currentUser, meeting:this.currentMeeting }), className:'xbaf hc vc' })});

this.demoCreationViewPopup.showPopup(this.context);
 }
  public hideDemoCreationView (  ) : void {
 this.demoCreationViewPopup ?. dispose();
 }
  public labelWithInputFieldonChanged  =  ( val : string,d3eState : GeneralSettingsPageRefs ) : void  =>  {
 this.setSearchBy(val);
 }
  public labelWithInputField1onChanged  =  ( val : string,d3eState : GeneralSettingsPageRefs ) : void  =>  {
 this.request.setDomine(val);
 }
  public get addMeetingButton (  ) {
 return this.d3eState.addMeetingButton ; 
 }
  public get searchButton (  ) {
 return this.d3eState.searchButton ; 
 }
 }
export default function GeneralSettingsPage ( props : GeneralSettingsPageProps ) {
 return React.createElement(_GeneralSettingsPageState,{ ..._GeneralSettingsPageState.defaultProps, ...props }) ; 
 }
